import * as React from 'react';
import S from './Breadcrumb.styles';
const Breadcrumb = ({ items, darkText = false }) => {
    const characterCount = items.map((x) => x.title.length).reduce((acc, cur) => acc + cur, 0);
    // If the character count is too long, only show the last two items (LMGR-62) //
    const isLong = characterCount > 40;
    return (React.createElement(S.Container, { "aria-label": "Breadcrumb", "data-theme": darkText ? 'dark' : 'light', "data-truncate": isLong }, items.map((item, index) => (React.createElement(S.Item, { key: item.id },
        React.createElement(S.Link, { href: item.url, "aria-current": index === items.length - 1 ? 'page' : undefined }, item.title))))));
};
export default Breadcrumb;
